export enum RESPONSE_LOGIN {
    CANTIDAD_REINTENTOS_SUPERADA = 1,
    CONTRASEÑA_INCORRECTA = 2,
    SESION_INICIADA_CON_VALIDA = 3,
    SESION_INICIADA_SIN_VALIDA = 4,
}